import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/Login.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/client/auth/otp/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'accept': 'application/json' },
        body: JSON.stringify({ email, phone: phone || null })
      });

      if (!response.ok) {
        const errorData = await response.json();
        const detail = errorData.detail;
        const msg = Array.isArray(detail)
          ? detail.map((d) => d.msg || JSON.stringify(d)).join('; ')
          : (typeof detail === 'string' ? detail : 'Gửi mã OTP thất bại. Vui lòng thử lại.');
        throw new Error(msg);
      }

      setSuccess('Mã OTP đã được gửi! Đang chuyển đến trang xác thực...');
      setTimeout(() => navigate('/verify-otp', { state: { email, phone } }), 1000);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const inputClass = "w-full pl-12 pr-4 py-4 bg-hp-surface-container-low border-none rounded-xl focus:ring-2 focus:ring-hupath-scout/30 transition-all font-body text-hp-on-surface placeholder:text-hp-outline";

  return (
    <div className="min-h-screen flex items-stretch overflow-hidden bg-hp-surface font-body text-hp-on-surface">

      {/* ── LEFT HERO PANEL ── */}
      <section className="hidden lg:flex lg:w-3/5 hp-hero-gradient--register relative flex-col justify-between p-12 overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="bg-white/90 backdrop-blur-md p-2 rounded-xl shadow-sm">
              <img src="/logo_simple.png" alt="HuPath Logo" className="w-10 h-10 object-contain" />
            </div>
            <h1 className="font-headline font-black text-3xl text-hupath-owl tracking-tight">HuPath</h1>
          </div>
        </div>

        <div className="relative z-10 max-w-2xl mb-12">
          <div className="inline-flex items-center gap-2 bg-white/30 backdrop-blur-xl px-4 py-2 rounded-full mb-6 text-hupath-owl font-headline font-bold text-sm">
            <span className="material-symbols-outlined text-sm">rocket_launch</span>
            Bắt đầu hành trình mới
          </div>
          <h2 className="font-headline text-5xl xl:text-6xl font-extrabold text-hupath-ink leading-[1.1] mb-6">
            Bắt đầu hành trình chinh phục Cambridge English! 🚀
          </h2>
          <p className="font-body text-xl text-hupath-ink/80 leading-relaxed max-w-lg italic">
            Tham gia cùng hàng nghìn học sinh đang khám phá con đường chinh phục tiếng Anh cùng HuPath.
          </p>
        </div>

        <div className="absolute inset-0 pointer-events-none">
          {/* Main Illustration Image */}
          <div className="absolute top-[15%] right-[5%] w-[60%] max-w-lg z-0">
            <div className="bg-white/80 rounded-xl p-6 shadow-xl shadow-hupath-gold/10 transform -rotate-2">
              <img
                alt="Kids adventure"
                className="rounded-lg w-full h-auto object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuB1JSOGyO1c-AOdv77PhJ0llZynigEB7WizLPShB9utG4tw7sdJ_gk98PU9Z3RvLQ2GNHfV0Dh9DLpF80GryG8F6izdnwo1LF-6z5PSXrizqWAMbPX64R6uLn_oukIfZ2XLVr-arbnnCnEC7u_05LP514DmPQk48H-D6Ny_U3ceCQ6z2ySLaLWDaFbZGR666WoIeoZG1bYCSFtsAgtKKEWT5oxEmI5ayvyoMd4o3UK54LXuEzKgpmAICgu4fcpI3Dt9MSojybt8tA"
              />
            </div>
          </div>
          {/* Floating Cloud Ornaments */}
          <div className="absolute top-1/4 right-1/4 w-48 h-24 bg-white/40 blur-2xl rounded-full opacity-60"></div>
          <div className="absolute bottom-1/3 left-1/4 w-64 h-32 bg-hupath-gold/30 blur-3xl rounded-full opacity-50"></div>
        </div>
      </section>

      {/* ── RIGHT FORM PANEL ── */}
      <main className="w-full lg:w-2/5 bg-white flex items-center justify-center p-6 md:p-12 relative overflow-y-auto">
        <div className="w-full max-w-md relative z-10">
          {/* Mobile Logo */}
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <img src="/logo_simple.png" alt="HuPath Logo" className="w-8 h-8 object-contain" />
            <span className="font-headline font-bold text-xl text-hupath-scout">HuPath</span>
          </div>

          <div className="mb-8">
            <h3 className="font-headline text-3xl font-bold text-hp-on-surface mb-3">Đăng ký tài khoản</h3>
            <p className="font-body text-base text-hp-on-surface-variant">
              Nhập email để nhận mã xác thực OTP
            </p>
          </div>

          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Email */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="email">Email</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">mail</span>
                <input id="email" type="email" placeholder="example@email.com" value={email}
                  onChange={(e) => setEmail(e.target.value)} required className={inputClass} />
              </div>
            </div>

            {/* Phone */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="phone">Số điện thoại</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">phone</span>
                <input id="phone" type="tel" placeholder="090 123 4567" value={phone}
                  onChange={(e) => setPhone(e.target.value)} className={inputClass} />
              </div>
            </div>

            {/* Terms */}
            <div className="flex items-start gap-3 py-2">
              <input type="checkbox" id="terms" checked={agreedTerms} onChange={(e) => setAgreedTerms(e.target.checked)}
                className="mt-1 w-5 h-5 rounded text-hupath-scout focus:ring-hupath-scout border-hp-outline-variant bg-hp-surface-container-low" />
              <label className="text-sm text-hp-on-surface-variant font-body" htmlFor="terms">
                Tôi đồng ý với <a className="text-hupath-scout font-medium hover:underline" href="/#">Điều khoản sử dụng</a> và <a className="text-hupath-scout font-medium hover:underline" href="/#">Chính sách bảo mật</a>
              </label>
            </div>

            {/* Error / Success */}
            {error && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 text-red-600 text-sm font-medium">
                <span className="material-symbols-outlined text-lg">error</span>{error}
              </div>
            )}
            {success && (
              <div className="flex items-center gap-2 bg-green-50 border border-green-300 rounded-xl px-4 py-3 text-green-600 text-sm font-medium">
                <span className="material-symbols-outlined text-lg">check_circle</span>{success}
              </div>
            )}

            {/* Submit */}
            <button type="submit" disabled={isLoading || !agreedTerms}
              className="w-full hp-button-gradient text-white font-headline font-bold text-lg py-4 rounded-xl shadow-[0px_8px_24px_rgba(42,107,48,0.25)] hover:scale-[1.02] active:scale-95 transition-all disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100">
              {isLoading ? (
                <><span className="material-symbols-outlined lf-spin text-xl">progress_activity</span> Đang gửi mã...</>
              ) : 'Gửi mã xác thực'}
            </button>
          </form>

          {/* Login Link */}
          <div className="mt-8 text-center">
            <p className="text-hp-on-surface-variant font-body">
              Đã có tài khoản?{' '}
              <Link to="/login" className="text-hupath-scout font-bold font-headline ml-1 hover:underline">Đăng nhập</Link>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Register;
